import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import pollStatus from '@/components/polls/page/blocks/status.vue'
import pollDownload from '@/components/polls/page/blocks/download.vue'
import pollStatistic from '@/components/polls/page/blocks/statistic.vue'
import pollSystemInfo from '@/components/polls/page/blocks/systemInfo.vue'
import pollRcpts from '@/components/polls/page/blocks/rcpts.vue'
import pollName from '@/components/polls/page/blocks/name.vue'
import pollQuests from '@/components/polls/page/blocks/quests.vue'


const config: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['status', 'download', 'statistic', 'systemInfo'], ['name', 'rcpts']],
    xs: [['name', 'rcpts', 'status', 'download', 'statistic', 'systemInfo']]
  },
  blocks: {
    status: {
      block: pollStatus,
      options: {}
    },
    download: {
      block: pollDownload,
      options: {}
    },
    statistic: {
      block: pollStatistic,
      options: {}
    },
    systemInfo: {
      block: pollSystemInfo,
      options: {}
    },
    rcpts: {
      block: pollRcpts,
      options: {}
    },
    name: {
      block: pollName,
      options: {}
    },
    quests: {
      block: pollQuests,
      options: {}
    },
  }
}
export default config